import  { request7,request8 } from "@/utils/request";

// 资讯Api
const infoApi = {
  // 首页
  getInformationById(data) {
    return request7({
      method: "POST",
      url: `/login/getInformationById/${data.id}`,
      data: data
    });
  },
  // 轮播
  getCoverById(data) {
    return request8({
      method: "POST",
      url: '/api/cover/getCoverByID',
      data: data
    });
  },
  // 开屏
  getPopupById(data) {
    return request8({
      method: "POST",
      url: 'api/popup/getPopupByID',
      data: data
    });
  }
};

export default infoApi;
